import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Modal, DropZone, Thumbnail, Text, Checkbox, Button, } from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";
import { setToast } from "../../store/actions/configActions";
import { parseCSV } from "../../helper";
import { saveRate } from "../../api/rates";
import constants from "../../store/constants";
import { saveShippingList, setOpenWidget } from "../../store/actions/shippingActions";
import PolarisModal from "../PolarisModal";
import CsvDocs from "../CsvDocs";
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';
const ImportCSV = props => {
    const { ConfigReducer, ShippingReducer } = useSelector(
        (state) => state
    );
    const { features, shopName, store } = ConfigReducer;
    const { openWidget } = ShippingReducer;
    const dispatch = useDispatch();
    const fetchJson = useAuthenticatedFetch();

    const [ratesPermission] = useState(features.indexOf(constants.RATES) >= 0)
    const [file, setFile] = useState(null);
    const [openDocs, setOpenDocs] = useState(false)
    const [isUploading, setIsUploading] = useState(false);

    const uploadCsv = async () => {
        if (!file) {
            dispatch(setToast({ active: true, content: "Please select file before uploading.", error: true }))
            return
        }
        if (ratesPermission) {
            setIsUploading(true);
            const formData = new FormData()
            formData.append("shippings-" + store.shop_id, file)
            formData.append("fileName", "shippings-" + store.shop_id)

            try {
                const data = await fetchJson(`/file/upload`, {
                    method: 'POST',
                    headers: { "shop_id": store.shop_id, "x-access-token": store.shop_id },
                    body: formData
                })
                if (data.records && data.records.length) {
                    dispatch(saveShippingList([...data.records]))
                }
                dispatch(setToast({ active: true, content: data.message, error: false }))
            } catch (error) {
                dispatch(setToast({ active: true, content: error.response?.data?.message || error.message, error: true }))
            } finally {
                dispatch(setOpenWidget(false));
                setFile(null);
                setIsUploading(false);
            }
            // const reader = new FileReader();
            // reader.onload = async () => {
            //     const csvText = reader.result;
            //     const rates = parseCSV(csvText)
            //     for (const Rate of rates) {
            //         for (const key in Rate) {
            //             if (Rate[key] && Rate[key].includes(";")) {
            //                 let arr = [...Rate[key].split(";")]
            //                 let keyValue = arr.map(val => ({ "label": val, "value": val }))
            //                 Rate[key] = [...keyValue]
            //             }
            //             Rate[key] = Rate[key] === "Yes" ? true : (Rate[key] === "No" ? false : Rate[key])
            //         }
            //         let _rate = {
            //             ...Rate,
            //             shop: store.shop_name,
            //             currency: store.shop_currency,
            //             unit: "kg",
            //             cost_by: "flat",
            //             priceBy: "flat",
            //             add_base_price: false,
            //             esteric_zip: Rate.zip_codes,
            //             modifiedCodes: Rate.zip_codes,
            //             shipping_ranges: []
            //         }
            //         await saveRate(_rate, Rate.id, ratesPermission, [], [], setIsUploading, dispatch, [], setErrors, null, rates.length === 1)
            //     }
            //     dispatch(setOpenWidget(false));
            //     setFile(null);
            //     setIsUploading(false);
            // };
            // reader.readAsText(file);

        } else {
            dispatch(setToast({ active: true, content: "This feature is not available in current plan.", error: true }))
        }
    };

    const handleDropZoneDrop = file => {
        if (file[0].type === "text/csv") {
            setFile(file[0]);
        } else {
            dispatch(setToast({ active: true, content: "Invalid file type, only .csv file type is allowed.", error: true }))
        }

    };

    const validImageTypes = ["text/csv"];
    const fileUpload = !file && <DropZone.FileUpload />;
    const uploadedfile = file && (
        <div style={{ padding: "0", textAlign: "center" }}>
            <Card>
                <span className="span-thumb">
                    <Thumbnail
                        size="small"
                        alt={file.name}
                        source={NoteIcon}
                    />
                </span>
                <div>
                    {file.name}{" "}
                    <Text variant="headingMd" as="h6">
                        <p className="file-size">{file.size} bytes</p>
                    </Text>
                </div>
            </Card>
        </div>
    );

    const downloadSampleCsv = async () => {
        try {
            const blob = await fetchJson(`/file/csv/sample`, { method: 'GET', parse: 'blob' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", "shippings_sample.csv")
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        } catch (error) {
            dispatch(setToast({ active: true, content: error.message, error: true }))
        }
    }

    return (
        <Modal
            open={openWidget}
            onClose={() => {
                dispatch(setOpenWidget(false));
                setFile(null);
            }}
            title="Upload CSV"
            primaryAction={{
                content: "Upload",
                loading: isUploading,
                onAction: uploadCsv,
                disabled: !file || isUploading
            }}
            secondaryActions={[
                {
                    content: "Cancel",
                    onAction: () => {
                        setFile(null);
                        dispatch(setOpenWidget(false));
                    },
                },
            ]}
        >
            <Modal.Section>
                <DropZone
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    accept="text/csv"
                >
                    {uploadedfile}
                    {fileUpload}
                </DropZone>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                    <Button variant="plain" monochrome onClick={() => setOpenDocs(true)} >
                        Learn about how to write CSV
                    </Button>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        
                        <span>Download a{" "}</span>
                        {/* <Button variant="plain" size="slim" onClick={downloadSampleCsv}>
                            sample CSV template
                        </Button> */}
                        <a
                            href="/file/csv/sample"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sample-csv-link"
                        >
                            sample CSV template
                        </a>{" "}
                    </div>
                </div>
                <PolarisModal
                    active={openDocs}
                    modalTitle="Learn about how to write CSV"
                    handleClose={() => setOpenDocs(false)}
                    secondaryActions={[{
                        content: "Close",
                        onAction: () => setOpenDocs(false)
                    }]}
                    component={<CsvDocs />}
                />
            </Modal.Section>
        </Modal>
    )
}

export default ImportCSV




